import { Component, input } from '@angular/core';
import { LucideAngularModule, type Sun } from 'lucide-angular';

@Component({
  selector: 'app-section-headline',
  templateUrl: './section-headline.component.html',
  imports: [LucideAngularModule],
})
export class SectionHeadlineComponent {
  iconImg = input<typeof Sun>(); // We just need the type LucideIconData any LucideIcon would do here
  iconColor = input<string>();
  title = input<string>();
  additionalClasses = input<string>('');
}
